import { useGetTenantGroupOverrides } from 'Hooks/query-hooks/tenant-groups/useGetTenantGroupOverrides';
import useGetReduxUsers from 'Hooks/reduxHelperHooks/useGetReduxUsers';
import { useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { addAdditionalBreadcrumbParams } from 'Store';
import errorController from 'Components/ErrorScreens';
import RouteLoading from 'Components/RouteLoading';
import { resolveRuleType } from 'Utils';
import useGetTenantGroupOverrideRulesColumns from 'Hooks/useGetTenantGroupOverrideRulesColumns';
import useGlobalRules from 'Hooks/query-hooks/global-rules/useGlobalRules';
import useGetTenantGroup from 'Hooks/query-hooks/tenant-groups/useGetTenantGroup';
import TenantGroupLandlordRulesTable from '../../components/TenantGroupRulesTable/TenantGroupLandlordRulesTable';
import TenantGroupPageHeader from '../../components/TenantGroupPageHeader';

import styles from './TenantGroupOverride.css';

const TenantGroupOverride = () => {
    const { tenantGroupId: tenantGroupIdString } = useParams<{ tenantGroupId: string }>();
    const tenantGroupId = Number(tenantGroupIdString);
    const location = useLocation();
    const dispatch = useDispatch();
    const { users } = useGetReduxUsers();
    const tenantGroupOverridesAPI = useGetTenantGroupOverrides({
        users,
        tenantGroupId: tenantGroupIdString,
        queryEnabled: true
    });

    const globalRulesAPI = useGlobalRules({});
    const tenantGroupAPI = useGetTenantGroup({
        tenantGroupId: tenantGroupIdString
    });
    // TODO: make the BE do this instead and strip out the FE code that does it in multiple places
    const landlordRulesFormatted = React.useMemo(() => {
        return {
            ...globalRulesAPI.data,
            rules: globalRulesAPI.data?.rules.map((rule) => {
                return { ...rule, ruleType: resolveRuleType(rule) };
            })
        };
    }, [globalRulesAPI.data]);

    useEffect(() => {
        dispatch(
            addAdditionalBreadcrumbParams({
                pathname: `/tenants/tenant-group/${tenantGroupId}`,
                params: {
                    tenantGroupName: tenantGroupAPI.data?.name
                }
            })
        );
    }, [location, tenantGroupId, tenantGroupAPI.data, dispatch]);

    const ruleTableColumns = useGetTenantGroupOverrideRulesColumns();
    const { hasError, errorCmp } = errorController([
        globalRulesAPI.error,
        tenantGroupOverridesAPI.error,
        tenantGroupAPI.error
    ]);

    if (
        tenantGroupOverridesAPI.isLoading ||
        tenantGroupOverridesAPI.isFetching ||
        globalRulesAPI.isLoading ||
        globalRulesAPI.isFetching ||
        tenantGroupAPI.isLoading ||
        tenantGroupAPI.isFetching
    ) {
        return <RouteLoading />;
    }

    if (hasError) return errorCmp;

    return (
        <div className={styles.pageContainer}>
            <TenantGroupPageHeader tenantGroupId={tenantGroupIdString} mode='tenantOverrideSelection' />

            <div className={styles.tableContainer}>
                <TenantGroupLandlordRulesTable
                    columnNames={ruleTableColumns}
                    // TODO: there is something weird with our Rule interface.
                    // our query hooks arent using that interface properly
                    // so we get a lot of type issues. once we have time, we need to fix it.
                    // @ts-ignore
                    globalRules={landlordRulesFormatted!}
                    tenantOverrideRules={tenantGroupOverridesAPI.data!}
                    mode='tenantOverrideSelection'
                />
            </div>
        </div>
    );
};

export default TenantGroupOverride;
